import { useMemo } from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { makeTaskNameByIdSelector } from "~/store/selectors/selector.tasks.jsx";

const TaskNameContainer = ({ id, forceWithoutNumber }) => {
  const getTaskNameById = useMemo(makeTaskNameByIdSelector, []);
  const children = useSelector((state) => getTaskNameById(state, id, forceWithoutNumber));

  return children;
};

TaskNameContainer.propTypes = {
  id: PropTypes.number.isRequired,
  forceWithoutNumber: PropTypes.bool,
};
TaskNameContainer.defaultProps = {
  forceWithoutNumber: false,
};

export default TaskNameContainer;
